import { useState, useEffect } from 'react';
import { isKeyList, getListName, checkListExist } from '../helpers';
import { useAllInOneContext, useActiveListContext } from '../context';

export default function useTargetListAdd() {
  const { activeList } = useActiveListContext();
  const { lists } = useAllInOneContext();

  const [targetList, setTargetList] = useState();
  const [listName, setListName] = useState();

  const [defaultList, setDefaultList] = useState(false);

  useEffect(() => {
    if (lists && lists.length && defaultList) {
      //alert(getListName(choice, lists));
      const choice = !isKeyList(activeList)
        ? checkListExist(activeList, lists)
          ? activeList
          : lists[0].docID
        : lists[0].docID;
      setTargetList(choice);

      setListName(getListName(choice, lists));
    }
  }, [defaultList, lists, activeList]);

  useEffect(() => {
    if (lists && lists.length) {
      setDefaultList(false);
      setListName(getListName(targetList, lists));
    }
  }, [targetList]);

  return {
    targetList,
    setTargetList,
    defaultList,
    setDefaultList,
    listName,
  };
}
